import { cevir } from "@/lib/dil";

/**
 * D-078 (U-077): triyaj sayfasındaki "Administrative action..." penceresinin Action alanı ve Save düğmesi (DogrulamaRiser.tsx).
 *
 * İdari kaydın dört tipi sunucudadır (muayene.controller.ts, değişmedi): "osi-iade" (Return to OSI; kalemi kapatmaz), "kanit"
 * (Close with evidence), "kabul" (Accept as-is), "reject" (Convert to Reject). Boş değer Action alanındaki "Select..." seçeneğidir:
 * aksiyon seçilmemiştir. Save aksiyonsuz basılamadığı için boş tip sunucuya hiç gitmez.
 */

/**
 * Pencere açılırken Action alanının ilk değeri; `mevcut` kalemin var olan idari kaydının tipidir (yoksa null).
 * Yeni kayıt boş açılır. Düzenlemede kapanmış kayıt ("kanit", "kabul") kendi tipiyle açılır; "Return to OSI" kaydı boş açılır
 * (K4: OSI cevap verince kalemi kapatmak isteyen kişi aksiyonu değiştirmeden kaydedip kalemi açık bırakmasın). "Convert to Reject"
 * kaydı olağan yolda (bu pencereden kaydedilince) kalemi değişim kalemlerine taşır ve düğme çıkmaz. Geçiş dosyasından
 * (ADMIN_CLOSURES) geri yüklenen "reject" kaydı ise kalemin sınıfını değiştirmez (rework-gecis.service.ts); kalem rework kartında
 * kalır ve "Edit administrative record" düğmesi çıkar. O da tanınmayan her değer gibi boş açılır.
 * Gerekçe, kanıt referansı ve Route card her açılışta boştur (K1); onları pencerenin kendisi boşaltır.
 */
export function idariIlkTip(mevcut: string | null | undefined): string {
  return mevcut === "kanit" || mevcut === "kabul" ? mevcut : "";
}

/**
 * Save'in açık olma koşulu: aksiyon seçili (D-078), gerekçe dolu ve "Close with evidence"ta kanıt referansı dolu (bugünkü iki koşul,
 * sunucunun ret kurallarıyla aynı). "Select..." yeniden seçilirse Save yine pasifleşir.
 */
export function idariKaydedilebilir(tip: string, gerekce: string, kanit: string): boolean {
  if (!tip || !gerekce.trim()) return false;
  return tip !== "kanit" || kanit.trim() !== "";
}

/**
 * Pasif Save'in ipucu (düğmenin title'ı; K2: fareyle üstüne gelince görünür, dokunmatik ekranda görünmez). Yalnız aksiyon boşken
 * vardır; aksiyon seçili ve gerekçe ya da kanıt boşken ipucu yoktur (bugünkü gibi; "Reason (mandatory)" etiketi söyler).
 */
export function idariSaveIpucu(tip: string): string | undefined {
  return tip ? undefined : cevir("Choose an action first.");
}
